export default __webpack_public_path__ + "static/media/creativity_inactive.f795e9aa.svg";